import React from "react"
import ReactLoading from "react-loading"

// const Loader = ({ type, color }) => (
//   <ReactLoading type={type} color={color}  />
// )
// examples https://www.npmjs.com/package/react-loading

const LoaderDefault = ({ isStart }) => {
  if (isStart) {
    return <ReactLoading type={"cubes"} color={"#3768b8"} />
  } else {
    return null
  }
}

export default LoaderDefault
